/**
 * @generated SignedSource<<1c5c467aeba3736e272ed83d641336eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JiraConfigStateConfigurationStatus = "CONFIGURED" | "NOT_CONFIGURED" | "NOT_INSTALLED" | "NOT_SET" | "PARTIALLY_CONFIGURED" | "PROVIDER_ACTION_CONFIGURED" | "PROVIDER_ACTION_NOT_CONFIGURED" | "%future added value";
export type homePageMainQuery$variables = {
  cloudID: string;
};
export type homePageMainQuery$data = {
  readonly jira: {
    readonly devOps: {
      readonly configStates: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly config: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly status: JiraConfigStateConfigurationStatus | null;
                } | null;
              }> | null;
            } | null;
            readonly id: string;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"capabilities_IntegrationsConfigStates" | "manage_IntegrationsConfigStates">;
        }> | null;
      } | null;
    } | null;
  } | null;
};
export type homePageMainQuery = {
  response: homePageMainQuery$data;
  variables: homePageMainQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudID"
  },
  {
    "kind": "Literal",
    "name": "providerTypeFilter",
    "value": [
      "DEVELOPMENT_INFO"
    ]
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "homePageMainQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JiraDevOpsQuery",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "JiraAppConfigStateConnection",
                "kind": "LinkedField",
                "name": "configStates",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraAppConfigStateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "manage_IntegrationsConfigStates"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "capabilities_IntegrationsConfigStates"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JiraAppConfigState",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "JiraConfigStateConnection",
                            "kind": "LinkedField",
                            "name": "config",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "JiraConfigStateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "JiraConfigState",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "homePageMainQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JiraDevOpsQuery",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "JiraAppConfigStateConnection",
                "kind": "LinkedField",
                "name": "configStates",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraAppConfigStateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JiraAppConfigState",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appDisplayName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appIconLink",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "JiraConfigStateConnection",
                            "kind": "LinkedField",
                            "name": "config",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "JiraConfigStateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "JiraConfigState",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "configureLink",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4c79b1884b63e49c46537468e7718118",
    "id": null,
    "metadata": {},
    "name": "homePageMainQuery",
    "operationKind": "query",
    "text": "query homePageMainQuery(\n  $cloudID: ID!\n) {\n  jira {\n    devOps {\n      configStates(cloudId: $cloudID, providerTypeFilter: [DEVELOPMENT_INFO]) @optIn(to: \"Jira-config-states-by-provider\") {\n        edges {\n          ...manage_IntegrationsConfigStates\n          ...capabilities_IntegrationsConfigStates\n          node {\n            id\n            config {\n              edges {\n                node {\n                  status\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment capabilities_IntegrationsConfigStates on JiraAppConfigStateEdge {\n  node {\n    id\n    appDisplayName\n    appIconLink\n    config {\n      edges {\n        node {\n          status\n          configureLink\n        }\n      }\n    }\n  }\n}\n\nfragment manage_IntegrationsConfigStates on JiraAppConfigStateEdge {\n  node {\n    id\n    appDisplayName\n    appIconLink\n    config {\n      edges {\n        node {\n          status\n          configureLink\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "52d58e18a7195a30a2d154faa42a11a8";

export default node;
